module.exports = __webpack_public_path__ + "img/YouTube.cd90215f.svg";